<script setup lang="ts">
const { setPageSeo } = useSeo()

await setPageSeo({
  title: 'Conditions Générales d\'Utilisation',
  description: 'Conditions générales d\'utilisation du site de l\'école OXO à Narbonne : accès au site, services fournis, limitations de responsabilité et droit applicable.'
})
</script>

<template>
  <div class="pt-32 pb-24 bg-slate-50 dark:bg-oxo-dark min-h-screen">
    <div class="container mx-auto px-6 max-w-4xl">
      <h1 class="font-display font-bold text-4xl mb-12 text-slate-900 dark:text-white">Conditions Générales d'Utilisation</h1>

      <div class="prose prose-lg dark:prose-invert max-w-none space-y-8">
        
        <p class="lead text-xl text-gray-600 dark:text-gray-300">
            L'utilisation du site de l'École OXO implique l'acceptation pleine et entière des conditions générales d'utilisation ci-après décrites. 
            Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment.
        </p>

        <section aria-labelledby="acces">
          <h2 id="acces" class="text-2xl font-bold mb-4 text-oxo-red">1. Accès au site</h2>
          <p>
            Le site est accessible gratuitement en tout lieu à tout utilisateur ayant un accès à Internet. 
            Tous les frais supportés par l'utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.
          </p>
        </section>

        <section aria-labelledby="services">
          <h2 id="services" class="text-2xl font-bold mb-4 text-oxo-red">2. Services fournis</h2>
          <p>
            Le site a pour objet de fournir une information concernant l’ensemble des activités de l'école (formations, projets étudiants, actualités).
            L'École OXO s’efforce de fournir des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes et des carences dans la mise à jour.
          </p>
        </section>

        <section aria-labelledby="responsabilite">
          <h2 id="responsabilite" class="text-2xl font-bold mb-4 text-oxo-red">3. Limitations de responsabilité</h2>
          <p>
            L'École OXO ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site.
            De plus, l’utilisateur du site s’engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour.
          </p>
        </section>

        <section aria-labelledby="droit">
          <h2 id="droit" class="text-2xl font-bold mb-4 text-oxo-red">4. Droit applicable</h2>
          <p>
            Tout litige en relation avec l’utilisation du site est soumis au droit français. 
            Il est fait attribution exclusive de juridiction aux tribunaux compétents de Narbonne.
          </p>
        </section>

      </div>
    </div>
  </div>
</template>
